import { computed } from 'vue';

import { KitchenTicket } from '../../../models/ModelRepository';
import { round } from 'lodash';

const useKitchenTicketItems = () => {
    const colors = [
        'green',
        'red',
        'blue',
        'pink',
        'yellow',
        'purple',
        'teal',
        'deep-purple',
        'light-blue',
        'indigo',
        'orange',
        'grey',
        'cyan',
        'light-green',
        'amber',
        'brown',
        'deep-orange',
        'blue-grey',
        'green accent-3',
        'red accent-3',
        'blue accent-3',
        'pink accent-3',
        'yellow accent-3',
        'purple accent-3',
        'teal accent-3',
        'deep-purple accent-3',
        'light-blue accent-3',
        'indigo accent-3',
        'orange accent-3',
        'grey accent-3',
        'cyan accent-3',
        'light-green accent-3',
        'amber accent-3',
        'brown accent-3',
        'deep-orange accent-3',
        'blue-grey accent-3',
    ];

    const tickets = computed(() => {
        const allTickets = KitchenTicket.all();
        return allTickets.filter((ticket) => ticket.isPending());
    });

    // Color map to store colors for each product ID
    const colorMap = new Map();

    const categoryItemsMap = computed(() => {
        const map = new Map();

        tickets.value.forEach((ticket) => {
            ticket.items.forEach((item) => {
                if (item.completed_at) return;

                const itemId = item.product_id;
                const categoryName = item.getCategory()?.name || '';

                if (!map.has(categoryName)) {
                    map.set(categoryName, []);
                }

                const existingItems = map.get(categoryName);
                const existingItem = existingItems.find((existing) => existing.id === itemId);

                if (!existingItem) {
                    // If color is already assigned to this product, reuse it; otherwise, assign a new color
                    let color = colorMap.has(itemId) ? colorMap.get(itemId) : colors.pop() || 'grey';

                    existingItems.push({
                        id: itemId,
                        color: color,
                        name: item.name,
                        count: round(item.count, 2),
                        category_id: item.getCategory()?.id,
                    });

                    // Store the color for this product ID
                    colorMap.set(itemId, color);
                } else {
                    existingItem.count += round(item.count, 2);
                }
            });
        });

        return map;
    });

    const allItems = computed(() => {
        const result = [];

        categoryItemsMap.value.forEach((items) => {
            result.push(...items);
        });

        return result;
    });

    const allItemsAndCategories = computed(() => {
        const result = [];

        categoryItemsMap.value.forEach((items, name) => {
            result.push({
                name: name,
                id: items[0].category_id,
                items: items,
            });
        });

        return result;
    });

    return {
        allItemsAndCategories,
        allItems,
    };
};

export default useKitchenTicketItems;
